/**
 * The nav badge counts endpoint: every badge in one request.
 */
import { apiGet } from '@shared/services/api';

/** Every nav badge count, as `GET /api/nav/counts` returns it. */
export interface NavCountsResponse {
  inbox: number;
  starred: number;
  later: number;
  drafts: number;
}

/**
 * Fetch the inbox, starred, later and drafts badge counts in one request.
 *
 * @returns The four counts, each computed server-side with a COUNT query.
 */
export async function fetchNavCounts(): Promise<NavCountsResponse> {
  return apiGet<NavCountsResponse>('/api/nav/counts');
}
